<template>
  <div v-if="currentDocument">
    <div :id="name" :style="(isVideo?'padding:0; ':'')+`display: none;`" class="lightcase-holder">
      <span v-if='currentDocument.no_document' class='reason-holder'>{{currentDocument.reason}}</span>
      <div class="js-video video-wrap" v-else-if="isVideo">
        <video width="320" height="240" controls>
          <source :src="currentDocument.url" type="video/mp4">
          <source :src="currentDocument.alternate_url" type="video/webm">
          Your browser does not support the video tag.
        </video>        
      </div>
      <div class="image-holder" v-else>
        <div class="js-lightcase-image image-holder__block">
          <img src="" :data-src="imageSrc">
        </div>
      </div>
      <div class="rotate-button" :style="rotateButtonStyles" v-if="!disableRotate && !currentDocument.no_document">
        <a href="#" class="rotate-left" style="font-size: 18px;padding: 3px 0;"><i class="fa fa-undo" aria-hidden="true"></i></a>
        <span class="btn">
          <span class="zoom-tools">
            <i>Zoom</i> <a id="zoomInIcon" href="javascript:void(0);" title="Zoom in">+</a>
            <a id="zoomOutIcon" class="disabled" href="javascript:void(0);" title="Zoom out">-</a>
            <a id="resetZoom" href="javascript:void(0);">Original size</a>
          </span>
          <a href="#" class="js-confirm-rotate-save">Save</a>
          /
          <a :href="downloadLink" download>Download</a>
        </span>
        <a href="#" class="rotate" style="font-size: 18px;padding: 3px 0;"><i class="fa fa-repeat" aria-hidden="true"></i></a>
      </div>
      <div class="image-facilities">
        <span v-if="showComputedDetails">
          <span style="text-transform: capitalize;">{{this.details?this.details.name:''}}</span>
          {{computedDetails}}
          <sup>2</sup>
        </span>
        <span v-else="" style="text-transform: capitalize;">{{this.details?this.details.name:''}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import configureLightcase from '../../lightcase.js';

  export default {
    components: {
    },
    data() {
      return {
        rotateButtonStyles: {
          width: '100%',
          height: '60px',
          boxSizing: 'border-box',
          backgroundColor: '#eeeeee',
          paddingLeft: '20px',
          paddingRight: '20px',
          marginTop: '12px',
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        },
        angle: 0,
        imageSource: ''
      }
    },
    computed: {
      showComputedDetails() {
        if (this.details && this.details.length && this.details.width) {
          return true
        } else {
          return false
        }
      },
      computedDetails() {
        return ('(' + this.details.length + ' x ' + this.details.width + ') ') + ((this.details.length * this.details.width - parseInt(this.details.length * this.details.width)) > 0 ? (this.details.length * this.details.width).toFixed(2) + ' m' : (this.details.length * this.details.width) + ' m')
      }
    },
    props: {
      currentDocument: {
        default: () => { },
        type: Object
      },
      name: {
        default: '',
        type: String
      },
      imageSrc: {
        default: '',
        type: String
      },
      disableRotate: {
        default: false,
        type: Boolean
      },
      isVideo: {
        default: false,
        type: Boolean
      },
      details: {
        default: () => { },
        type: Object
      },
      downloadLink: {
        default: '#',
        type: String
      }
    },
    mounted() {
      configureLightcase();
    },
    updated() {
      console.log('upd');
      configureLightcase();
    }
  }
</script>

<style lang="scss">

  @page {
    margin: 20mm 15mm;
  }

  @media print {
  body {
    margin: 0 !important;
  }
  
  #page-top {
    background: none !important;
    padding-top: 15px !important;
  }
  
  body > *:not(#lightcase-case),
  #lightcase-info,
  .rotate-button,
  .image-facilities {
    display: none !important;
  }
  
  #lightcase-case {
    position: static;
    margin: 0 !important;
    width: 100% !important;
    text-align: center;
  }
  
  .lightcase {
    &-contentInner  {
      width: 100% !important;
      height: 100% !important;
    }
    
    &-content {
      text-align: center;
    }
    
  }
  
  .image-holder {
    display: block;
    overflow: visible;
    img  {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/admin/components/VLightcaseHolder.vue